webpackJsonp([212839066777427],{

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'column' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Also on ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://medium.com/simars', target: '_blank' },
	          '[Medium]'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Programming, Architecture, Concepts & Trends'
	      )
	    ),
	    data.allMarkdownRemark.edges.map(function (post) {
	      return _react2.default.createElement(
	        'div',
	        { key: post.node.id },
	        _react2.default.createElement(
	          'h3',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.node.frontmatter.path },
	            post.node.frontmatter.title
	          )
	        ),
	        _react2.default.createElement(
	          'small',
	          null,
	          'Posted by ',
	          post.node.frontmatter.author,
	          ' on',
	          ' ',
	          post.node.frontmatter.date
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('hr', null)
	      );
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = BlogPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-6cbd02b284cedde744f2.js